/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'svg-shaft': {
    width: 370.977,
    height: 370.977,
    viewBox: '0 0 98.154 98.154',
    data: '<path pid="0" d="M16.043 90.655h72.43c5.347 0 9.681-18.615 9.681-41.578 0-22.962-4.334-41.577-9.68-41.577H16.042c5.347 0 9.681 18.615 9.681 41.577 0 22.963-4.334 41.578-9.681 41.578zm20.685-35.843v-11.47h11.47v11.47zm19.344 0v-11.47h11.47v11.47zm19.344 0v-11.47h11.47v11.47zM9.68 7.5a9.681 41.577 0 0 1 9.681 41.577 9.681 41.577 0 0 1-9.68 41.577A9.681 41.577 0 0 1 0 49.077 9.681 41.577 0 0 1 9.681 7.5z"/>'
  }
})
